import {createContext, useState} from "react";

export const Context = createContext({});

export const Provider = props => {

    const {children} = props;
    const [handleSaveFunction, setHandleSaveFunction] = useState(null);
    const [handleRenameFunction, setHandleRenameFunction] = useState(null);
    const [handleDeleteFunction, setHandleDeleteFunction] = useState(null);
    const [handleRefreshFunction, setHandleRefreshFunction] = useState(null);
    const [handleExportFunction, setHandleExportFunction] = useState(null);
    const [handleDownloadFunction, setHandleDownloadFunction] = useState(null);
    const [handleCancelTradeFunction, setHandleCancelTradeFunction] = useState(null);
    const [handleCancelAssetTransferFunction, setHandleCancelAssetTransferFunction] = useState(null);
    const [handleCompleteSwiftWiresFunction, setHandleCompleteSwiftWiresFunction] = useState(null);
    const [handleSwiftTransactionCompleteFunction, setHandleSwiftTransactionCompleteFunction] = useState(null);
    const [handleSwiftTransactionRejectFunction, setHandleSwiftTransactionRejectFunction] = useState(null);
    const [savedSearchName, setSavedSearchName] = useState('');
    const [exportRowData, setExportRowData] = useState(null)
    const [handleApproveFunction, setHandleApproveFunction] = useState(null);
    const [handleRejectFunction, setHandleRejectFunction] = useState(null);
    const [isValidApprover, setIsValidApprover] = useState(true);
    const [isValidRejecter, setIsValidRejecter] = useState(true);
    const [isDeletable, setIsDeletable] = useState(true);
    // default status, is PEND before
    const [defaultStatus, setDefaultStatus] = useState("PEND");


    const handleRefresh = (refreshCriteria, onSuccess, onError) => {
        handleRefreshFunction.handleRefresh(refreshCriteria, handleRefreshFunction.gridApi, onSuccess, onError)
    }

    const handleSave = (name, onSuccess, onError) => {
        handleSaveFunction.handleSave(name, handleSaveFunction.gridApi, onSuccess, onError)
    }

    const handleRename = (listName, onSuccess, onError) => {
        handleRenameFunction.handleRename(listName,
            handleRenameFunction.gridApi, onSuccess, onError);
    }

    const handleDelete = (onSuccess, onError) => {
        handleDeleteFunction.handleDelete(handleDeleteFunction.gridApi, onSuccess, onError);
    }

    const handleExport = (type, rowData, onSuccess, onError) => {
        handleExportFunction.handleExport(type, rowData, handleExportFunction.gridApi, onSuccess, onError);
    }

    const handleDownload = () => {
        handleDownloadFunction.handleDownload(handleDownloadFunction.gridApi.getSelectedRows()[0]);
    }

    const  handleTradeCancel = (userSelectedRows, onSuccess, onError) => {
        handleCancelTradeFunction.handleTradeCancel(userSelectedRows, onSuccess, onError);
    }

    const  handleAssetTransferCancel = (userSelectedRows, onSuccess, onError) => {
        handleCancelAssetTransferFunction.handleAssetTransferCancel(userSelectedRows, onSuccess, onError);
    }
    const  handleSwiftWiresComplete = (userSelectedRows, onSuccess, onError, swiftWireReference) => {
        handleCompleteSwiftWiresFunction.handleSwiftWiresComplete(userSelectedRows, onSuccess, onError, swiftWireReference);
    }
    const  handleSwiftTransactionComplete = (userSelectedRows, onSuccess, onError, completeComment) => {
        handleSwiftTransactionCompleteFunction.handleSwiftTransactionComplete(userSelectedRows, onSuccess, onError, completeComment);
    }
    const  handleSwiftTransactionReject = (userSelectedRows, onSuccess, onError) => {
        handleSwiftTransactionRejectFunction.handleSwiftTransactionReject(userSelectedRows, onSuccess, onError);
    }
    const handleApprove = (comment, onSuccess, onError) => {
        handleApproveFunction.handleApprove(comment, handleApproveFunction.gridApi.getSelectedRows(), onSuccess, onError);
    }

    const handleReject = (comment, onSuccess, onError) => {
        handleRejectFunction.handleReject(comment, handleRejectFunction.gridApi.getSelectedRows(), onSuccess, onError);
    }

    const actionPanelContext = {
        setHandleSaveFunction,
        setHandleRenameFunction,
        setHandleDeleteFunction,
        setHandleRefreshFunction,
        setSavedSearchName,
        setHandleExportFunction,
        setHandleDownloadFunction,
        setHandleCancelTradeFunction,
        setHandleCancelAssetTransferFunction,
        setHandleCompleteSwiftWiresFunction,
        setHandleApproveFunction,
        setHandleRejectFunction,
        handleSave,
        handleRename,
        handleDelete,
        handleRefresh,
        handleExport,
        handleDownload,
        handleTradeCancel,
        handleAssetTransferCancel,
        handleSwiftWiresComplete,
        handleApprove,
        handleReject,
        savedSearchName,
        handleExportFunction,
        exportRowData,
        setExportRowData,
        isValidApprover,
        setIsValidApprover,
        isValidRejecter,
        setIsValidRejecter,
        isDeletable,
        setIsDeletable,
        defaultStatus,
        setDefaultStatus,
        handleSwiftTransactionComplete, setHandleSwiftTransactionCompleteFunction, handleSwiftTransactionReject, setHandleSwiftTransactionRejectFunction
    }
    return <Context.Provider value={actionPanelContext}>{children}</Context.Provider>

};

export const { Consumer } = Context;
